"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBadge = StatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
// Predefined status mappings
var statusColorMap = {
    // User status
    active: "success",
    inactive: "default",
    locked: "danger",
    // Organization & Product status
    enabled: "success",
    disabled: "default",
    // Voucher status
    available: "success",
    assigned: "warning",
    delivered: "primary",
    faulty: "danger",
    expired: "default",
    // Order status
    pending_authorization: "warning",
    authorized: "success",
    rejected: "danger",
    processing: "primary",
    completed: "success",
    cancelled: "default",
    failed: "danger",
    // Disbursement status
    pending: "warning",
    scheduled: "secondary",
    queued: "primary",
};
function StatusBadge(props) {
    var status = props.status, type = props.type, _a = props.size, size = _a === void 0 ? "sm" : _a;
    // Handle undefined or null status
    if (!status) {
        return ((0, jsx_runtime_1.jsx)(react_1.Chip, { color: "default", size: size, variant: "flat", children: "Unknown" }));
    }
    var normalizedStatus = status.toLowerCase().replace(/ /g, "_");
    var color = type || statusColorMap[normalizedStatus] || "default";
    // Format the display label
    var displayLabel = status
        .replace(/_/g, " ")
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return ((0, jsx_runtime_1.jsx)(react_1.Chip, { color: color, size: size, variant: "flat", children: displayLabel }));
}
